import SubscriptionHistoryRoute from "./SubscriptionHistoryRoute";

export default SubscriptionHistoryRoute;
